// extracted by mini-css-extract-plugin
export default {"platform":"Platform_platform__Xwcnd","platformWrapper":"Platform_platformWrapper__qhmMv","button":"Platform_button__PLU7o"};